import { useNavigate } from 'react-router-dom';

/** Go to the previous screen, or `fallback` when this is the first history entry. */
export function useNavigateBack(fallback: string) {
  const navigate = useNavigate();

  return () => {
    const idx = (window.history.state as { idx?: number } | null)?.idx;
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1);
      return;
    }
    navigate(fallback);
  };
}
